module.exports = __webpack_public_path__ + "static/beholder-1ea8c6f6b3fafb2eb125d7694d8f9696.jpg";